import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Icon } from '../../../../../Icon/Icon';
import { IconName } from '../../../../../Icon/Icon.types';
import { CollapsibleContext } from '../../../../Collapsible.context';
import { useOnClick } from './hooks/useOnClick/useOnClick';
export const ToggleButton = () => {
    const { isOpen } = useContext(CollapsibleContext);
    const onClick = useOnClick();
    return (_jsx("div", { className: 'cursor-pointer', onClick: onClick, children: _jsx(Icon, { size: 'md', name: isOpen ? IconName.REMOVE : IconName.ADD }) }));
};
